/* eslint-disable max-len */
import React from 'react'
import {connect} from 'react-redux'
import {storePayload} from '../actions/storePayload.js'
import {Button} from '@lazarusai/forms-ui-components'
import '../styles/Splash.css'

function Splash(props) {
  function onClickEnter() {
    props.storePayload({
      step: 'file-upload',
    })
  }
  return (
    <div id='splash-page'>
      <div id='splash-content'>
        <h1 className='title'>ALFRED</h1>
        <div>
          <p>
            {`Hello! I’m ALFRED, an artificial intelligence specifically designed to streamline the defense acquisition process for the Department of Defense. I provide a purpose-built model, user interface, and user experience, allowing users to easily navigate and select the most suitable acquisition pathways. In addition, I provide you with rapid generation of acquisition strategies and documentation, based on your direction, to facilitate planning and execution of programs.`}
          </p>
          <p>
            {`To interact with me effectively, users should use simple conversational prompts, such as asking questions or providing information related to the acquisition program.`}
          </p>
        </div>
        <Button
          style={{
            backdropFilter: 'initial',
          }}
          onClick={onClickEnter}
          theme={props.theme}
          text='Next'
          width={'33%'}
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  step: state.userReducer.step,
  theme: state.userReducer.theme,
})

export default connect(
    mapStateToProps,
    {storePayload},
)(Splash)
